// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"543":"ce4c003c","613":"5a67468f"}[chunkId] + ".chunk.js";
};